import React from 'react';
import { MuiThemeProvider, createTheme } from '@material-ui/core/styles';
// import {
//   light,
//   grey,
//   dark,
//   disabledColor,
//   backgroundColor,
//   primaryColor,
//   primaryColorLight,
//   secondaryColor,
//   tertiaryColor,
//   bodyColor,
//   titleColor,
// } from 'helpers/colors';


const palette = {
    type: 'light',
    primary: {
      main: '#FCB813', // bleu
      // light: '#6fcaf2', //bleu light
      light: '#DCEDEE', //bleu light
      dark: '#EB9200',
      contrastText: '#2D5E77'
    },
    secondary: {
      main: '#4CA1A6', // rouge
      // light: '#4CA1A6',
      light: '#4CA1A6',
      dark: '#2D5E77',
      contrastText: '#fff',
    },
    tertiary: {
      main: '#87c7a6',
    },
    text: {
      primary: '#212121',
      light: '#858B8E'
      // secondary: secondaryColor,
      // light,
      // dark,
    },
    action: {
      // disabled: disabledColor,
    },
    background: {
      default: '#f5f5f5',
      input: '#fff',
      // paper: '#fff',
    },
    header: {
      buttonColor: '#2D5E77',
      buttonBackgroundColor: 'transparent',
      buttonBorder: '',
      buttoBorderBottom: '4px transparent solid',
      buttoHoverColor: '#EB9200',
      // buttonHoverBorderBottom: '4px #E37EB3 solid',
      buttonSelectedColor: '#2D5E77',
      buttonSelectedBackgroundColor: 'transparent',
      buttonSelectedBeforeContent: "' '",
      buttonSelectedBorderBottom: '4px #EB9200 solid',
      buttonFontWeight: 'bold'
    },
    faq: {
      backgroundColor: undefined,
      bulletColor: '#6C207E',
      itemColor: '#0087AF',
      itemBackgroundColor: '#fff',
      itemShadow: '1px 1px 6px #666',
      textColor: '#0087AF',
      answerColor: '#0087AF',
    },
    speedTest: {
      backgroundColor: 'transparent',
      color: '#fff',
      buttonColor: '#fff',
      buttonBackgroundColor: '#4CA1A6',
    },
    footer: {
      color: '#fff',
      linkColor: '#fff',
      background: 'linear-gradient(90deg, #2D5E77 0%, #4CA1A6 100%)'
    },
    news: {
      backgroundColor: '#4CA1A6',
      color: '#fff'
    },
    replays: {
      breadCrumbColor: '#fff',
      backgroundColor: '#4CA1A6',
    },
    live: {
      breadCrumbColor: '#fff',
      backgroundColor: '#B2D7DB',
    },
    template: {
      color: '#212121'
    },
    registration: {
      titleColor: '#212121'
    },
    rgpd: {
      backgroundColor: '#3F7275',
      color: '#fff',
    }
  }

export default class Theme extends React.Component {
  render() {
    const { children } = this.props;

    const theme = createTheme({
      palette,
      typography: {
        // fontFamily: ['Aleo, Arial, sans-serif'].join(','),
        fontFamily: ['Museo, arial, sans-serif'].join(','),
        useNextVariants: true,
        h1: {
          // fontSize: '3.625rem',
          fontSize: '3.125rem',
          marginTop: 8*4,
          marginBottom: 8*12,
          textAlign: 'center',
          // color: palette.primary.dark,
          color: '#fff',
          fontWeight: 600
        },
        h2: {
          fontSize: '2.1875rem',
          '& a': {
            color: 'inherit'
          }
        },
        h3: {
          fontSize: '2rem',
          marginBottom: 24,
          color: palette.secondary.dark,
          fontWeight: 600
        },
        h5: {
          fontSize: '1.375rem',
          color: palette.secondary.dark,
          display: 'block',
          lineHeight: '2.1875rem',
          '& .MuiSvgIcon-root': {
            // marginTop: -6,
            marginRight: 8,
            // marginBottom: 8
          }
        },
        h6: {
          color: palette.secondary.dark,
          fontWeight: 'bold',
        },
        body1: {
          fontSize: '0.9375rem',
          lineHeight: '1.4375rem'
        },
        caption: {
          lineHeight: '1.4375rem',
          color: '#898089'

        }
      },
      breakpoints: {
        values: {
          xs: 0,
          sm: 600,
          md: 960,
          lg: 1280,
          xl: 1920,
        },
      },
      overrides: {
        PrivateTabIndicator: {
          colorSecondary: {
            backgroundColor: '#FCB813'
          }
        },
        MuiSvgIcon: {
          root: {
            display: 'inline-block',
            verticalAlign: 'middle',
            marginTop: -3,
            marginRight: 4
          }
        },
        MuiBadge: {
          colorSecondary: {
            backgroundColor: '#FCB813'
          }
        },
        MuiAvatarGroup: {
          avatar: {
            color: palette.secondary.light,
            border: '2px '+palette.secondary.light+' solid',
            backgroundColor: '#fff'
          }
        },
        MuiAvatar: {
          root: {
              border: '2px '+palette.secondary.light+' solid'
          }
        },
        MuiInputLabel: {
          root: {
            fontWeight: 'bold',
            color: '#000',
          }
        },
        MuiButton: {
          root: {
            fontSize: '0.875rem',
            textTransform: 'none',
            borderRadius: 20,
            fontWeight: 'normal',
            '& .MuiSvgIcon-root': {
              display: 'inline-block',
              verticalAlign: 'middle',
              marginTop: -2,
              marginRight: 5
            },
            '&.MuiButton-containedPrimary': {
              boxShadow: 'none',
              color: '#fff',
              backgroundColor: palette.secondary.main,
              border: '1px '+palette.secondary.main+' solid',
              borderRadius: '35px',
              paddingTop: 12,
              paddingBottom: 12,
              paddingLeft: 24,
              paddingRight: 24,
              textTransform: 'uppercase'

            },
            '&.MuiButton-containedPrimary:hover': {
              boxShadow: 'none',
              backgroundColor: '#fff',
              color: palette.secondary.main,
            },
            '&.MuiButton-containedSecondary': {
              boxShadow: 'none',
              color: palette.secondary.main,
              backgroundColor: '#fff',
              border: '1px '+palette.secondary.main+' solid',
              borderRadius: '35px',
              paddingTop: 12,
              paddingBottom: 12,
              paddingLeft: 24,
              paddingRight: 24,
              textTransform: 'uppercase'

            },
            '&.MuiButton-containedSecondary:hover': {
              boxShadow: 'none',
              backgroundColor: palette.secondary.main,
              color: '#fff',
            },
            '&$disabled': {
              color: '#fff'
            }
          },
          contained: {
            '&$disabled': {
              color: 'original',
              backgroundColor: 'original',
              opacity: .4
            }
          }
        },
        // MuiFormLabel: {
        //   root: {
        //     // color: '#fff',
        //     '&.Mui-focused': {
        //       // color: primaryColor,
        //     },
        //   },
        // },
        // MuiFormHelperText: {
        //   root: {
        //     color: primaryColor,
        //   },
        // },
        // 'MuiStepper-root': {
        //   padding: 0,
        // },
        // MuiStep: {
        //   root: {
        //     '& > .MuiStepConnector-root': {
        //       display: 'none',
        //     },
        //   },
        // },
        // MuiMenuItem: {
        //   root: {
        //     // color: '#fff',
        //   },
        // },
        // MuiAlert: {
        //   standardSuccess: {
        //     // color: '#fff',
        //     fontWeight: 'bold'
        //   }
        // }
      },
    });

    // theme.overrides.MuiButton.root.boxShadow = theme.shadows[2];
    // theme.typography.h1 = {
    //   ...theme.typography.h1,
    //   marginTop: theme.spacing(2),
    //   marginBottom: theme.spacing(5),
    //   paddingLeft: theme.spacing(2),
    //   paddingRight: theme.spacing(2),
    //   // boxShadow: theme.shadows[3],
    //   [theme.breakpoints.down('md')]: {
    //     fontSize: '1.4rem',
    //   },
    //   [theme.breakpoints.down('sm')]: {
    //     fontSize: '1.3rem',
    //   },
    //   [theme.breakpoints.down('xs')]: {
    //     fontSize: '1.1rem',
    //   },
      // [theme.breakpoints.up('xs')]: {
    //     fontSize: '2.4rem',
    //   },
    //   [theme.breakpoints.up('sm')]: {
    //     fontSize: '3.5rem',
    //   },
    //   [theme.breakpoints.up('md')]: {
    //     fontSize: '4rem',
    //   },
    //   [theme.breakpoints.up('lg')]: {
    //     fontSize: '5rem',
    //   },
    //   [theme.breakpoints.up('xl')]: {
    //     fontSize: '5.5rem',
    //   },
    // };

    // theme.typography.h2 = {
    //   ...theme.typography.h2,
    //   // [theme.breakpoints.up('xs')]: {
    //   //   fontSize: '1.5rem',
    //   //   textAlign: 'center',
    //   // },
    //   // [theme.breakpoints.up('sm')]: {
    //   //   fontSize: '2.2rem',
    //   // },
    //   // [theme.breakpoints.up('md')]: {
    //   //   fontSize: '2.6rem',
    //   //   textAlign: 'left',
    //   //   lineHeight: '4.8rem',
    //   // },
    //   // [theme.breakpoints.up('lg')]: {
    //   //   fontSize: '3rem',
    //   //   lineHeight: '5.2rem',
    //   // },
    //   // [theme.breakpoints.up('xl')]: {
    //   //   fontSize: '3.5rem',
    //   //   lineHeight: '5.8rem',
    //   // },
    // };
    //
    // theme.overrides['MuiContainer'] = {
    //   fixed: {
    //     [theme.breakpoints.down('lg')]: {
    //       maxWidth: '100%',
    //     },
    //   },
    // };

    // console.log('generated theme', theme)
    // console.log('theme debug', getMuiTheme(getCustomPalette(currentUserGroup)))
    return <MuiThemeProvider theme={theme}>{children}</MuiThemeProvider>;
  }
}



// WEBPACK FOOTER //
// ./src/components/Theme.jsx